module.exports = __webpack_public_path__ + "static/forbes-a7fa9fb796b9ea7048421a07e16dfa32.png";